<template>
  <div class="login">
    <div class="logo">
          <img src="../assets/f-und-s-logo.svg"> <div class="title">F&S</div>
    </div>
    <input type="text" v-model="email" v-on:keyup.13="login" placeholder="E-Mail">
    <input type="password" v-model="password" v-on:keyup.13="login" placeholder="Passwort">
    <button v-on:click="login" v-on:keyup.13="login" class="button">Einloggen</button>
  </div>
</template>
<script>
  import firebase from 'firebase'
  
  export default {
    name: "Login",
    data: function(){
      return {
        email: '',
        password: ''
      }
    },
    methods: {
      login: function(){
        //this.$router.replace('hello');
        firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(
          ( user ) => {
            this.$router.replace('hello');
          },
          function( err ) {
            alert( 'Oops ' + err.message );
          }
        )        
      }
    }
  }
</script>
<style scoped>
  .logo { display: flex; justify-content: center; align-items: stretch; }
  .logo img { display: inline-block; width: 2em; height: 2em; margin: 0 0 0 0; }
  .logo .title { background: none; color: #000; display: inline-block; vertical-align:middle; line-height: 2.03333rem; padding: 0 0.6333333em; font-weight: 600; display: none; }

    @media screen and (min-width: 768px) {
      .logo .title { display: inline-block; }
    }  

  .login { height: calc(100vh - 3.322333em -3.322333em); margin: 0 0 0; display: flex; justify-content: center; align-items: center; flex-direction: column;  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue